import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';
import { InfoContextProvider } from './contexts/InfoContext';
import { HomeRefinanceContextProvider } from './contexts/HomeRefinanceContext';
import { CarRefinanceContextProvider } from './contexts/CarRefinanceContext';

ReactDOM.render(
  <BrowserRouter>
    <InfoContextProvider>
      <HomeRefinanceContextProvider>
        <CarRefinanceContextProvider>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </CarRefinanceContextProvider>
      </HomeRefinanceContextProvider>
    </InfoContextProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
